import React from "react";
import ReactCursorPosition from "react-cursor-position";
import Paginator from "./Paginator";
import RaisedButton from "./RaisedButton";
import FlatButton from "./FlatButton";
import MediaViewerImage from "./MediaViewerImage";
import AnnotationsSlide from "./AnnotationsSlide";
import AddAnnotationPanel from "./AddAnnotationPanel";
import MediaViewerPdf from "./MediaViewerPdf";

const mediaPlaceholder =
  "https://crello.com/de/create/flyers/images/flyers-memorable-banner.png";

const sampleData = {
  projectInfo: {
    id: "RF23OP",
    name: "Sommer Spaß",
    client: "Kunde XY"
  },
  media: [
    {
      type: "image",
      url:
        "https://scontent.fham2-1.fna.fbcdn.net/v/t1.0-9/37886216_2262023630789596_1701608661912125440_n.jpg?_nc_cat=0&oh=8450f8ed80f2dc4f6ab755d5f71c11e4&oe=5BD70908",
      annotations: [
        {
          id: "femf903290",
          type: "good",
          text:
            "Ich finde das richtig gut! Diese Kreise sind einfach so perfekt rund!",
          marker: { positionX: 15, positionY: 55 }
        },
        {
          id: "qwd213e12ed",
          type: "bad",
          text:
            "Also das finde ich wirklich scheiße! Ich meien ein Flugzeug macht ja nu wirklich ken sin! Und nochmal: Also das finde ich wirklich scheiße! Ich meien ein Flugzeug macht ja nu wirklich ken sin!",
          marker: { positionX: 62, positionY: 8 }
        },
        {
          id: "243f2f3f42frg2we",
          type: "bad",
          text: "Alter? Was soll das? Ein Surfbrett? Das ist doch total dumm!",
          marker: { positionX: 50, positionY: 30 }
        },
        {
          id: "3r1r31232ff23q",
          type: "good",
          text: "Sehr schöne 14! Die ist wirklich sehr elegant.",
          marker: { positionX: 85, positionY: 80 }
        }
      ]
    },
    {
      type: "image",
      url:
        "https://ae01.alicdn.com/kf/HTB1ldmHbv5TBuNjSspcq6znGFXau/Dekoration-k-he-berge-landschaft-verarbeitung-lustige-sch-ne-tiere-Seide-Stoff-Plakat-druck-DW234.jpg_640x640.jpg",
      annotations: [
        {
          id: "432t432t",
          type: "good",
          text: "Süüüüüüüüüüüüüüüüüüüüüüüüüüüüüüüüüß! DAS IST SO KNUFFIG!",
          marker: { positionX: 20, positionY: 60 }
        },
        {
          id: "rthtjrkr5u4",
          type: "bad",
          text:
            "Ihhgitt! Das ist mir wirklich viel zu eklig. Ich mag keine Popos!",
          marker: { positionX: 78, positionY: 50 }
        }
      ]
    }
  ]
};

let sasmpleData = {
  projectInfo: {
    id: "RF23OP",
    name: "Sommer Spaß",
    client: "Kunde XY"
  },
  media: [
    {
      type: "image",
      url:
        "https://ae01.alicdn.com/kf/HTB1ldmHbv5TBuNjSspcq6znGFXau/Dekoration-k-he-berge-landschaft-verarbeitung-lustige-sch-ne-tiere-Seide-Stoff-Plakat-druck-DW234.jpg_640x640.jpg",
      annotations: []
    }
  ]
};

class MediaViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullScreen: false,
      selectedMediaIndex: 0,
      selectedAnnotation: "3r1r31232ff23q",
      addAnnotationPanel: { visible: false, nextX: 0, nextY: 0 }
    };
  }

  setFullScreen(enabled) {
    this.setState({ fullScreen: enabled });
  }

  componentWillReceiveProps(props, state) {
    if (props.isScrolling) {
      this.rcp.reset();
    }
  }

  onSelectAnnotation(id) {
    this.setState({ selectedAnnotation: id });
  }

  onMediaNavigate(newMediaIndex) {
    this.setState({
      selectedMediaIndex: newMediaIndex,
      selectedAnnotation: ""
    });
  }

  addAnnotationMarker(x, y) {
    this.setState({
      addAnnotationPanel: { visible: true, nextX: x, nextY: y }
    });
  }

  addAnnotation(data) {
    const selectedMedia = sampleData.media[this.state.selectedMediaIndex];
    selectedMedia.annotations.push({
      id: makeid(),
      type: data.type,
      text: data.text,
      marker: {
        positionX: this.state.addAnnotationPanel.nextX,
        positionY: this.state.addAnnotationPanel.nextY
      }
    });
  }

  render() {
    const selectedMedia = sampleData.media[this.state.selectedMediaIndex];

    return (
      <div className="MediaViewer">
        <div id="TopBar">
          <p>{sampleData.projectInfo.name}</p>
          <span>
            <FlatButton label="Später Abschließen" />
            <RaisedButton label="Abschließen" />
          </span>
        </div>
        {this.state.fullScreen ? (
          <div id="FullScreenView">
            <div
              id="FullScreenBtn"
              onClick={() => {
                this.setFullScreen(false);
              }}
            >
              <i class="fas fa-times" />
            </div>
            <div id="Media">
              <img src={selectedMedia.url} />
            </div>
          </div>
        ) : null}
        <div id="View">
          {this.state.addAnnotationPanel.visible ? (
            <AddAnnotationPanel
              addNewAnnotation={data => this.addAnnotation(data)}
              onHide={() => {
                this.setState({
                  addAnnotationPanel: { visible: false }
                });
              }}
            />
          ) : null}
          <div
            id="FullScreenBtn"
            onClick={() => {
              this.setFullScreen(true);
            }}
          >
            <i className="fas fa-expand" />
          </div>
          <ReactCursorPosition
            ref={rcp => (this.rcp = rcp)}
            className="MediaViewerImageContainer"
          >
            <MediaViewerImage
              editable={this.props.editable}
              addMarker={(x, y) => this.addAnnotationMarker(x, y)}
              imageUrl={selectedMedia.url}
              isScrolling={this.props.isScrolling}
              onSelectAnnotation={id => this.onSelectAnnotation(id)}
              annotations={selectedMedia.annotations}
              selectedAnnotation={this.state.selectedAnnotation}
            />
          </ReactCursorPosition>
        </div>
        <AnnotationsSlide
          onSelectAnnotation={id => this.onSelectAnnotation(id)}
          annotations={selectedMedia.annotations}
          selectedAnnotation={this.state.selectedAnnotation}
        />
        <Paginator
          info={`Auftrag: ${sampleData.projectInfo.id}`}
          totalPages={sampleData.media.length}
          onNavigate={id => this.onMediaNavigate(id)}
        />
      </div>
    );
  }
}

export default MediaViewer;

class AnnotationMarker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return <div className="AnnotationMarker" />;
  }
}

function makeid() {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 10; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}



// WEBPACK FOOTER //
// ./src/components/MediaViewer.js